import {React} from 'react'
import Footer from './Footer'
import { interpolateLegal } from '../helpers/legalContent'

const PrivacyPolicy = ({data, html}) => {
  if (html) {
    return (
      <>
        <div
          className="legal-document"
          style={{padding:'8em'}}
          dangerouslySetInnerHTML={{__html: interpolateLegal(html, data)}}
        />
        <Footer data={data} />
      </>
    )
  }

  return (
    <>
    <div style={{padding:'8em'}}>
        <h5 class="wp-block-heading">Our Privacy Policy was Last Updated on May 15, 2023</h5>



<p>The {data.brandname} Privacy Policy provides important information on the types of personal information that it may collect, use, or process about you when you visit our website or interact with {data.brandname}. We value your privacy and are committed to safeguarding your information. Please review this Policy to learn about the privacy practices at {data.brandname}.</p>



<p>Please read this Privacy Policy carefully. By visiting our Site and Application and using our Services, you agree that your information, including your personal information, will be handled as described in this Privacy Policy.</p>



<h3 class="wp-block-heading">Applicability And Third-Party Websites And Services</h3>



<p>This Privacy Policy is only applicable to this website: {data.brandurl}. This statement is limited in nature to only be relevant and govern the material in this website. This Privacy Policy does not govern and is not applicable to any third party or any website that may be linked on {data.brandurl}. This Privacy Policy only governs the collection, processing and storing of personal information supplied to this website; it does not govern the collection, processing or storing of personal information by any third party.</p>



<h3 class="wp-block-heading">Information We May Collect</h3>



<p>Generally, we as well as third-party vendors, networks, ISP(s) and supporting advertisers use technologies such as cookies, web beacons, and javascript applications to collect a variety of types of information about you when you interact with us or use the Platform through. Examples of the categories of information that may be collected include personal information, demographic information, behavioral information, and indirect information. Sometimes we collect combinations of these types of information:</p>



<p>Personal Information. Is information that can be used to identify you or any other individual to whom the information may relate. This is information which you are prompted to provide to us. Examples of Personal Information are your name, address, phone number(s) and email address, employment status or other unique information about you which you provide to us during the registration process or through the course of communicating with us. We may collect this same information about other persons when you provide it to us.</p>



<p>Demographic Information. Is information that may or may not be unique to you in the sense that it refers to selected population characteristics. Examples of demographic information are your zip code, mobile phone carrier, age, gender, salary range, education, marital status, occupation, military service, industry of employment, personal and online interests.</p>



<p>Behavioral Information. Is information which is automatically collected when you use the Platform. Examples of behavior information are the areas of the Platform that you visit, what services you access, information about your computer hardware and software, including your IP address, geographic location, browser preference, operating system type, domain names, times that you access the internet, and other websites you have visited.</p>



<p>Third-Party Information. Is information we acquire from a third-party which may include personal, demographic, behavioral and indirect information. This may also include, but is not limited to, first party cookies, third-party cookies, anonymous cookies, persistent identifiers, email opt-in records and search engine keywords. We may also receive information third parties derive from government entities which publicly post your information. We have no access or control over these cookies and other tracking devices used by third parties including advertisers and networks, internet service providers, data analytics providers or social networks and platforms and we have no responsibility or liability for the policies and practices of these parties.</p>



<p>Children’s Information. We do not knowingly collect information from anyone under the age of 13. If we obtain actual knowledge that we have collected Personal Information about a person under the age of 13, that information will be immediately deleted from the database.</p>



<h3 class="wp-block-heading">How we use Your Information</h3>



<p>We use the information we collect in various ways, including to:</p>



<ul>
<li>Provide, operate, and maintain our website</li>



<li>Improve, personalize, and expand our website</li>



<li>To fulfill any other purpose which you provide it</li>



<li>Understand and analyze how you use our website</li>



<li>Develop new products, services, features, and functionality</li>



<li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>



<li>Send you emails regarding our first or third-parties goods and services that may be of interest</li>



<li>To notify you of changes to the site or it’s features</li>



<li>To provide our services</li>



<li>To respond to inquiries</li>



<li>Find and prevent fraud</li>



<li>For any other purpose with your consent</li>
</ul>



<h3 class="wp-block-heading">Disclosure of Your Information</h3>



<p>We may disclose any information that is not identify an individual without any restriction. </p>



<p>Personal information collected as described in this privacy policy may be disclosed:</p>



<ul>
<li>To our partners, affiliates and subsidiaries</li>



<li>To fulfill the purpose which you provide it</li>



<li>For any purpose disclosed when the information was provided</li>



<li>To third parties to market their products or services if you have not opted out</li>



<li>To a buyer in the event of a merger, acquisition, restructure, dissolution or other transfer of assets</li>



<li>To our contractors, service providers and 3rd party partners to support our business and who will be held to our data privacy policies and confidentiality</li>



<li>With your consent</li>
</ul>



<p>​</p>



<p>Your information may also be disclosed where required by law, legal process, and to comply with any government or regulatory requirement. To enforce agreement terms. Or if we believe the disclosure is required to protect the rights or sage of {data.brandname}, it’s customers or the great public.</p>



<p>{data.brandname} is committed to complying with the CAN-SPAM Act (15 USC 7704) and related regulations. If you do not want us to share your Personally Identifiable Information (PII) with third parties for marketing purposes related to their products and/or services, you may submit a request using the form below.</p>



<h3 class="wp-block-heading">Targeted Ads And Analytics Services</h3>



<p>Third-party advertising and analytics services companies may place advertisements on our behalf onto other websites, perform tracking and reporting functions for those sites and our advertisements, and place third-party advertisements on our Website. These third parties may collect information about the websites you have viewed and advertisements with which you have interacted. Other information that may be collected include your IP address, date and time of interaction, your Internet Service Provider (ISP), and the browser you use to visit this Website. This information may be combined with PII, like your name or email address, and may be used to deliver advertising from us or from other companies, through email or through social media sites. This combined information may also be used to improve our understanding of your interactions with our Website and advertisements.</p>



<h3 class="wp-block-heading">Cookies And Other Technology</h3>



<p>Cookies and other technologies are used by {data.brandname} in its operation of {data.brandurl} to improve the experience of our visitors, to provide personalized content, and to monitor marketing campaigns and other communications. Cookies are small data files that can be used to track and use information about our visitors. These cookies make it possible for your information to be stored for your convenience, helping us to remember you and your preferences during your visit and during future visits. While some cookies terminate when you close your browser, some may remain on your computer or device until deleted.</p>



<h3 class="wp-block-heading">Your Choices Regarding Collection Of Your Information.</h3>



<p>You have several choices in regard to how your information is collected and used by {data.brandname}. First, you may choose not to provide us with any personal information when you visit {data.brandurl}. Additionally, your browser may allow for you to decline cookies from our website. Please note that some services provided by {data.brandname} may not work without this information.</p>



<h3 class="wp-block-heading">California Residents</h3>



<ul>
<li>Right to Know About Personal Information Collected, Disclosed, or Sold</li>



<li>(a) You have the right to request that we disclose to you what categories and specific pieces of personal information we have collected. Personal information does not include: (i) publicly available information from government records; (ii) de-identified or aggregated consumer information; (iii) information excluded from the scope of the California Consumer Privacy Act (“CCPA”); and (iv) personal Information covered by certain sector-specific privacy laws</li>



<li>(b) You may submit a verifiable consumer request to obtain the specific personal information we have collected about you either by emailing us at privacy@{data.brandurl} with “CCPA Request” in the subject line.</li>



<li>(c) Upon receiving your verifiable consumer request, the CCPA requires that we verify that you are the same consumer with whom we have the information in our systems. We may require that you verify your identity by clicking on a link we will send to the email address we have for you in our system or by responding to an email we send you.</li>



<li>(d) Personal information has been collected from the following categories of sources:</li>



<li>Information collected directly and indirectly from your activity on our Platform and your interactions or communications with us. This includes your Personal Information provided by you in connection with obtaining a certain product or service offered by us or one of our network providers or advertisers.
<ul>
<li>Information you provide us when you enter promotions or contests offered by us or our clients including networks and advertisers.</li>



<li>Information you provide us through surveys, customer service correspondence, and general feedback.</li>



<li>Analytics companies who provide demographic information such as gender, zip code, or any information that is not tied to your Personal Information. In addition, we may receive information about you from other online or offline sources, including third parties from whom we validate consumer self-reported information, and verify information we already have about you. This helps us to update, expand and analyze our records and provide products and services that may be of interest to you.</li>



<li>We also collect information provided by service providers and other third parties as set out herein, our advertisers, ad networks and third-party technology companies.</li>
</ul>
</li>



<li>(e) We disclose or share personal information for the following purposes:
<ul>
<li>To obtain the services or products you have registered for on our Platform.</li>



<li>To allow a third-party to market their products or services to you.</li>



<li>To provide you with information, products or services that you request from us or resolve consumer concerns or request to opt-out of marketing.</li>



<li>To provide you with notices concerning our products or services, or events or news, that may be of interest to you.</li>



<li>To improve our Platform, products and services, and present its contents to you including testing, research, analysis and product development.</li>



<li>To personalize your Platform experience and deliver content, product and service offerings relevant to your interests, including targeted offers and ads through our Platform, third-party sites, and via email or text message (with your consent, where required by law).</li>



<li>To maintain the safety, security, and integrity of our Platform as well as products and services, databases and other technology assets, and business.</li>



<li>To respond to government or law enforcement requests and as required by applicable law, court order, or governmental regulations.</li>



<li>To evaluate or conduct a corporate restructuring, reorganization, dissolution, or other sale or transfer of some or all of our business or assets.</li>



<li>As described to you when collecting your Personal Information or as otherwise set forth in CCPA.</li>
</ul>
</li>



<li>(f) We disclose Personal Information to our Service Providers and the following categories of third parties:
<ul>
<li>Our affiliated entities.</li>



<li>Data aggregators.</li>



<li>Advertisers.</li>



<li>Ad networks.</li>



<li>Third parties in connection with products or services we and/or third parties provide to you.</li>
</ul>
</li>



<li>Right to Request Deletion of Personal Information.</li>



<li>(a) You have a right to request the deletion of your Personal Information if we have collected or maintained it in the past 12 months.</li>



<li>(b) You may submit a verifiable consumer request to delete your information by sending an email to privacy@{data.brandurl} with “CCPA Request” in the subject line.</li>



<li>(c) Once we receive and confirm your verifiable consumer request, we will disclose to you the categories of Personal Information we collected about you and the categories of sources for the Personal Information we collected about you.</li>



<li>(d) This policy has disclosed our business or commercial purpose for collecting or selling that Personal Information and the categories of third parties with whom we shared that Personal Information.</li>



<li>Right to Opt-Out of the Sale of Personal Information. You have the right to opt-out of any sale of your Personal Information by us. If you are requesting a product or service, this is an exemption from this right, and we will process your request. However, you have the right to cease all further sale of your Personal Information.</li>



<li>Right to Non-Discrimination for the Exercise of a Consumer’s Privacy Rights. You have a right not to receive discriminatory treatment by us for the exercise of these privacy rights conferred by the CCPA. As such, we will not deny you goods or services, charge you different prices or rates for goods or services, or deny you discounts or other benefits; nor will we provide you a different level or quality of goods or services or recommend a different level or quality of goods or services.</li>



<li>Authorized Agent. Only you or a person registered with the California Secretary of State that you authorize to act on your behalf, may make a verifiable consumer request related to your Personal Information.</li>



<li>Limitations on Requests. You may only make a verifiable consumer request for access twice within a twelve (12) month period. The verifiable consumer request must: (a) provide sufficient information that allows us to reasonably verify you are the person about whom we collected Personal Information or your authorized agent; and (b) describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to you. The CCPA does not allow us to provide you with Personal Information if we cannot verify your identity or authority to make the request and confirm that the Personal Information relates to you. Making a verifiable consumer request does not require you to create an account with us. We will only use Personal Information provided in a verifiable consumer request to verify the requestor’s identity or authority to make the request.</li>



<li>Response Time and Response Format. We make every effort to respond to a verifiable consumer request within forty-five (45) days of its receipt. If we require more time (up to 90 days), we will inform you of the reason and extension period in writing by email. We will deliver our written response by email. Any disclosures we provide will only cover the twelve (12) month period preceding the verifiable consumer request’s receipt. The response we provide will also explain the reasons why we cannot comply with a request, if applicable. We will provide our response in a manner that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance to you.</li>



<li>Changes to California Resident Privacy Notice. We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will enforce the terms of the new policy going forward. You will receive no other notice than an updated posting on this page. Please check back each time you use or visit our Platform.</li>
</ul>



<h3 class="wp-block-heading">Notice to Non-US Users</h3>



<p>The Platform is published in the United States and intended only for US users. We attempt to protect the personally identifiable information of all users of our Platform and we attempt to comply with local data protection and consumer rights laws to the extent they may apply to the Platform, but our Platform is targeted to United States citizens and our policies are directed at compliance with those laws. If you are uncertain whether this Privacy Policy conflicts with the applicable local privacy laws where you are located, you should not utilize the Platform or provide any personal information.</p>



<p>If you are located outside the United States, you should be aware that your personally identifiable information will be transferred to the United States, the laws of which may be deemed by your country to have inadequate data protection. If you are located in a country outside the United States and voluntarily submit personally identifiable information to us, you thereby consent to the general use of such information as provided in this privacy policy and to the transfer of that information to, and/or storage of that information in, the United States.</p>



<h3 class="wp-block-heading">Children’s Privacy</h3>



<p>{data.brandname} is committed to upholding the privacy of children under the age of 13 years-old. {data.brandname} does not knowingly collect information of children under the age of 13. {data.brandname} will remove any personal information on children younger than 13 when made aware of collecting any.</p>



<h3 class="wp-block-heading">Updates To This Privacy Policy</h3>



<p>{data.brandname} reserves the right to change or update our Privacy Policy at any time and without advance notice. The updated policy will be applicable from the “effective date.” Please consider occasionally reviewing our Policy to remain informed on how {data.brandname} may collect, use, and share personal information.</p>



<h3 class="wp-block-heading">How We Protect Your Information</h3>



<p>We take our responsibility to secure the information we collect and maintain seriously. We use reasonable security, including technical, physical and administrative controls, to secure the information we collect and maintain. However, we cannot guarantee that these practices will prevent every unauthorized attempt to access, use, or disclose information. You can help protect the privacy of your own information by using encryption and other techniques to prevent unauthorized interception of your personal information. You are responsible for the security of your information that you transmit to us or view, download, or otherwise access when using unencrypted, public or otherwise unsecured networks. For more information on things you can do to help protect the privacy of your own information, visit www.OnGuardOnline.gov.</p>



<h3 class="wp-block-heading">Contact Us</h3>



<p>For more information about our privacy practices at {data.brandname}, please contact out to us at privacy@{data.brandurl}.</p>
    </div>
    <Footer data={data} />
  </>
  )
}

export default PrivacyPolicy
